import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import FinishedTasksList from './NotDoneTasksList';

export default ColumnsContent(FinishedTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/NotDoneTasksList/index.js